<template>
  <div class="plan-overview">
    <div class="plan-header">
      <span class="plan-title">{{ planData && planData.name ? planData.name : $t('map.floorPlan') }}</span>
      <span class="plan-sub">{{ sceneName }}</span>
    </div>
    <el-radio-group v-model="floorPlanTab" size="mini" class="view-tabs" @change="onTabChange">
      <el-radio-button label="device">{{ $t('map.deviceView') }}</el-radio-button>
      <el-radio-button label="asset">{{ $t('map.assetView') }}</el-radio-button>
    </el-radio-group>
    <div class="floor-plan-container" @dblclick="handleDblClick">
      <canvas id="planCanvas" class="floor-plan-canvas"></canvas>
    </div>

    <div class="floor-plan-hint">
      <i class="el-icon-info"></i>
      <span>{{ $t('map.floorPlanHint') }}</span>
    </div>
    <div v-if="point" class="device-detail-panel" :style="{ left: hoverPos.x + 15 + 'px', top: hoverPos.y + 15 + 'px' }" @click.stop>
      <!--<div class="device-detail-header">-->
      <!--  <span class="device-detail-title">{{ selectedItem.title }}</span>-->
      <!--  <i class="el-icon-circle-close color-red font-16" @click="close_detail"></i>-->
      <!--</div>-->
      <div class="device-detail-content">
        <p class="mb-10">
          <i v-if="!point.ex && point.on" class="el-icon-circle-check color-green"></i>
          <i v-else class="el-icon-warning-outline color-red"></i>
          {{ point.code }}
        </p>
        <p v-if="point.setup != null" class="mb-10">
          <i class="el-icon-price-tag"></i>{{ point.setup }}
        </p>
        <p class="mb-10" v-if="!point.range">
          <i class="el-icon-time"></i>{{ point.time }}
        </p>
        <div v-if="point.range" class="uk-flex mb-10" v-for="(item, index) in point.range" :key="index">
          <div>
            <p class="mb-10">
              <i class="el-icon-time"></i>{{ point.time }}
            </p>
            <p class="mb-10 font-14" style="color: #000;text-align: center;cursor: pointer;" @click="toDeviceHistory">
              <i :class="[{'el-icon-caret-top': item.ex === 1}, {'el-icon-caret-bottom': item.ex === 2}]"></i>{{ item.val }}
            </p>
            <p style="text-align: center;">{{ item.range }}</p>
          </div>
        </div>
        <div class="uk-flex mb-10" v-if="point.description">
          <div>
            <p>
              <i class="el-icon-document"></i>{{ point.description }}
            </p>
          </div>
        </div>
        <p style="text-align: right;">
          <span class="under-line" @click="toDeviceHistory">点击查看更多</span>
        </p>
      </div>
    </div>

    <el-dialog :visible.sync="fullscreenVisible" fullscreen class="fullscreen-dialog" @open="onFullscreenOpen" @close="onFullscreenClose">
      <div class="fullscreen-content" @click="fullscreenVisible = false">
        <canvas id="fullscreenPlanCanvas" class="fullscreen-canvas"></canvas>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { sceneGetPlanDetail, getBindDevicePosition } from '@/api/modules/architecture.js'
import bus from '@/utils/bus.js'
import { getInstance, handlePlanData, PLAN_INFO_TYPE } from '@/utils/planUtil-mf.js'
import { sensorHistoryQueryFormat } from '@/utils/simplify/query'
import { sensorHistory } from '@/utils/winDetail'

export default {
  name: 'PlanOverview',
  computed: {
    PLAN_INFO_TYPE () {
      return PLAN_INFO_TYPE
    },
    positionList () {
      return this.floorPlanTab === 'device' ? this.deviceList : this.carrierList
    }
  },
  data () {
    return {
      sceneName: '',
      floorPlanTab: 'device',
      planData: {},
      deviceList: [],
      carrierList: [],
      selectedItem: null,
      planModel: null,
      resizeHandler: null,
      animationTimer: null,
      myCanvas: null,
      pmNewObj: {},
      fullscreenVisible: false,
      fullscreenPlanModel: null,
      fullscreenTimer: null,
      hoverPos: { x: 0, y: 0 },
      point: null
    }
  },
  props: ['sceneId'],
  watch: {
    sceneId: {
      handler (newVal) {
        console.log('PlanOverview watch sceneId -> ', newVal)
        if (newVal) {
          this.loadPlanData()
        }
      },
      immediate: true
    },
    floorPlanTab () {
      this.selectedItem = null
      if (this.planModel) {
        this.renderCurrentTab()
      }
    }
  },
  mounted () {
    this.resizeHandler = () => {
      this.$nextTick(() => {
        this.initCanvas()
      })
    }
    window.addEventListener('resize', this.resizeHandler)

    if (this.sceneId) {
      this.loadPlanData()
    }
  },
  beforeDestroy () {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler)
    }
    if (this.animationTimer) {
      clearInterval(this.animationTimer)
    }
    if (this.planModel) {
      this.planModel.clear()
    }
  },
  methods: {
    async loadPlanData () {
      const planRes = await sceneGetPlanDetail({ sceneId: this.sceneId })
      if (planRes.result) {
        this.planData = planRes.result
        this.pmNewObj = { ...planRes.result }
        if (this.pmNewObj.bgImage && !this.pmNewObj.base64Path) {
          this.pmNewObj.base64Path = this.pmNewObj.bgImage
        }
        if (this.planData.planId) {
          const deviceRes = await getBindDevicePosition(this.planData.planId)
          this.deviceList = (deviceRes.result || []).map(item => handlePlanData(item, PLAN_INFO_TYPE.DEVICE))
          this.carrierList = (this.planData.carrierPositionList || []).map(item => handlePlanData(item, PLAN_INFO_TYPE.CARRIER))
          this.pmNewObj.devicePositionList = this.deviceList
          this.pmNewObj.carrierPositionList = this.carrierList
          this.$nextTick(() => {
            this.initCanvas()
          })
        }
      }
    },
    clearPlanModule () {
      if (this.planModel) this.planModel.clear()
    },
    resetCanvasTimer () {
      if (this.animationTimer) clearInterval(this.animationTimer)
      this.animationTimer = setInterval(() => {
        this.replayAnchor()
      }, 500)
    },
    replayAnchor () {
      const param = { nameParam: 'title', statusParam: 'abnormal' }
      const list = this.positionList ? [...this.positionList] : []
      this.initPoint(list, param)
    },
    initCanvas () {
      this.myCanvas = document.getElementById('planCanvas')
      if (!this.myCanvas) return

      const container = this.myCanvas.parentElement
      this.myCanvas.width = container.clientWidth
      this.myCanvas.height = container.clientHeight - 4

      this.clearPlanModule()
      this.initParam()
    },
    initParam () {
      const that = this
      that.$nextTick(() => {
        if (!that.planModel) {
          that.planModel = getInstance({
            id: 'planCanvas',
            move: true,
            wheelZoom: false,
            dotInfo: true,
            mouseup: (img, down, drop, data, x, y, pos, target, e) => {
              if (target && target.data && target.data.type === that.PLAN_INFO_TYPE.DEVICE) {
                if (e.button === 0) {
                  that.toDeviceHistory()
                }
              }
            },
            mousemove: (down, drop, data, pos, target, e) => {
              if (target && target.data && target.data.type === that.PLAN_INFO_TYPE.DEVICE) {
                const newId = target.data.id
                const oldId = that.selectedItem?.id
                if (newId !== oldId) {
                  that.selectedItem = target.data
                  that.show_detail()
                }
                that.hoverPos = { x: e.clientX, y: e.clientY }
              } else {
                that.selectedItem = null
                that.point = null
              }
            }
          })
        }

        that.initImage()
        that.putPoint(that.positionList)
      })

      this.resetCanvasTimer()
    },
    initImage (img) {
      if (!this.planModel) return
      this.planModel.draw([], img || this.pmNewObj.base64Path || '0')
    },
    putPoint (array) {
      if (!this.planModel) return
      this.planModel.setData([], true, true)
      if (array && array.length > 0) {
        const param = {
          nameParam: 'title',
          statusParam: 'abnormal'
        }
        this.initPoint(array, param)
      }
    },
    initPoint (array = [], param) {
      if (!this.planModel) return
      this.planModel.flashing = false
      this.planModel.setData([], true, true, param)
      if (array && array.length > 0) {
        this.planModel.setData(array, true, true, param)
      }
    },
    onTabChange () {},
    handleDblClick () {
      if (this.pmNewObj.base64Path) {
        this.fullscreenVisible = true
      }
    },
    onFullscreenOpen () {
      this.$nextTick(() => {
        const canvas = document.getElementById('fullscreenPlanCanvas')
        if (!canvas || !this.pmNewObj.base64Path) return

        canvas.width = window.innerWidth
        canvas.height = window.innerHeight

        this.fullscreenPlanModel = getInstance({
          id: 'fullscreenPlanCanvas',
          move: false,
          wheelZoom: false,
          dotInfo: true,
          mouseup: (img, down, drop, data, x, y, pos, target, e) => {
            if (target && target.data) {
              if (e.button === 0) {
                this.toDeviceHistory()
              }
            }
          },
          mousemove: (down, drop, data, pos, target, e) => {
            if (target && target.data) {
              const newId = target.data.id
              const oldId = this.selectedItem?.id
              if (newId !== oldId) {
                this.selectedItem = target.data
                this.show_detail()
              }
              this.hoverPos = { x: e.clientX, y: e.clientY }
            } else {
              this.selectedItem = null
              this.point = null
            }
          }
        })

        this.fullscreenPlanModel.draw([], this.pmNewObj.base64Path)

        if (this.positionList && this.positionList.length > 0) {
          const param = { nameParam: 'title', statusParam: 'abnormal' }
          this.fullscreenPlanModel.setData(this.positionList, true, true, param)
        }

        this.fullscreenTimer = setInterval(() => {
          if (this.fullscreenPlanModel && this.positionList) {
            const param = { nameParam: 'title', statusParam: 'abnormal' }
            const list = [...this.positionList]
            this.fullscreenPlanModel.setData([], true, true, param)
            this.fullscreenPlanModel.setData(list, true, true, param)
          }
        }, 500)
      })
    },
    onFullscreenClose () {
      if (this.fullscreenTimer) {
        clearInterval(this.fullscreenTimer)
        this.fullscreenTimer = null
      }
      if (this.fullscreenPlanModel) {
        this.fullscreenPlanModel.clear()
        this.fullscreenPlanModel = null
      }
      this.selectedItem = null
    },
    renderCurrentTab () {
      this.putPoint(this.positionList)
    },
    getDeviceTypeName (catalog) {
      const catalogMap = {
        0: this.$t('map.temperatureSensor'),
        1: this.$t('map.Gateway'),
        2: this.$t('map.Display'),
        3: this.$t('map.Relay'),
        5: this.$t('map.gasSensor'),
        6: this.$t('map.doorMagnetic'),
        7: this.$t('map.airSensor')
      }
      return catalogMap[catalog] || this.$t('map.unknownDevice')
    },
    getProbeData (probeStr, type) {
      try {
        const probe = JSON.parse(probeStr)
        if (probe[type] && probe[type].val !== undefined) {
          const unit = type === 'temp' ? '°C' : '%RH'
          return probe[type].val + unit
        }
      } catch (e) {
        console.error('Parse probe data error:', e)
      }
      return '-'
    },
    show_detail () {
      this.point = null
      const item = { ...this.selectedItem.obj }
      const pos = {
        dev_id: item.deviceId,
        dev: item.deviceCatalog,
        type: item.deviceType,
        is_circle: item.deviceCatalog !== 1,
        ex: false
      }
      pos.code = item['deviceCode']
      pos.time = item['updateTime'] ? this.$timetransition(item['updateTime']) : '-'
      pos.description = item['description']
      pos.left = item.xpos - (item.deviceCatalog == 0 ? 6 : 10)
      pos.top = item.ypos - (item.deviceCatalog == 0 ? 6 : 10)
      if (item.deviceCatalog == 0) {
        pos.type_desc = (item.deviceType % 2 === 0 ? 'H' : 'T') + (item.deviceType % 2 === 0 ? item.deviceType - 1 : item.deviceType)
      }
      if (item.deviceCatalog == 1) {
        pos.type_desc = item.deviceType == 1 ? 'G' : (item.deviceType == 2 ? 'G1' : 'G2')
      }
      if (item.deviceCatalog == 2) {
        pos.type_desc = 'D' + item.deviceType
      }
      if (item.deviceCatalog == 3) {
        pos.type_desc = 'R' + item.deviceType
      }
      if (item.deviceCatalog == 5) {
        pos.type_desc = 'G' + item.deviceType
      }
      if (item.deviceCatalog == 6) {
        pos.type_desc = 'M' + item.deviceType
      }
      pos.on = item.deviceStatus == 1
      if ('mount_point_name' in item) {
        pos.setup = item['mount_point_name']
      }
      let probe = null
      pos.probe_val = []
      if ('probe' in item) {
        probe = JSON.parse(item.probe)
        if (item.deviceCatalog == 0) {
          pos.probe_val.push({ key: 'temp', val: probe['temp']['val'], unit: '℃' })
          if (item.deviceType % 2 === 0) {
            pos.probe_val.push({ key: 'hum', val: probe['hum']['val'], unit: '%RH' })
          }
        }
        if (item.deviceCatalog == 5) {
          pos.probe_val.push(item.deviceType == 6 ? {
            key: 'coz',
            val: probe['coz']['val'],
            unit: '%VOL'
          } : { key: 'gas', val: probe['gas']['val'], unit: probe['gas']['unit'] })
        }
        if (item.deviceCatalog == 6) {
          pos.probe_val.push({
            key: 'magnetism',
            val: probe['magnetism']['val'] == 0 ? 'OFF' : 'ON',
            unit: ''
          })
        }
      }
      if ('probe_range' in item && 'rangeList' in item) {
        pos.range = []
        item.rangeList.forEach((k, i) => {
          const meaning = {
            code: k['unitCode'],
            range: (k['min'] + k['unit_name'] + '~' + k['max'] + k['unit_name']),
            val: probe != null ? probe[k.unitCode]['val'] + k['unit_name'] : '---'
          }
          if (probe != null && ((!pos.ex) && (probe[k.unitCode]['val'] > k['max'] || probe[k.unitCode]['val'] < k['min']))) {
            pos.ex = true
            meaning.ex = probe[k.unitCode]['val'] > k['max'] ? 1 : (probe[k.unitCode]['val'] < k['min'] ? 2 : 0)
            pos.probe_val.forEach((it, no) => {
              if (it.key == k.unitCode && it.val > k['max']) {
                it.ex = 1
              }
              if (it.key == k.unitCode && it.val < k['min']) {
                it.ex = 2
              }
            })
          }
          pos.range.push(meaning)
        })
      }
      this.point = pos
    },
    toDeviceHistory () {
      const row = this.selectedItem.obj
      if (row.deviceCatalog === 0 || row.deviceCatalog === 5 || row.deviceCatalog === 6) {
        const params = sensorHistoryQueryFormat(this.selectedItem)
        params.tagId = row.deviceCode
        if (row.deviceCatalog === 5) {
          if (row.deviceType === 6) {
            params.probe = 'coz'
          } else {
            params.probe = 'gas'
          }
          params.devCatalog = 5
        } else if (row.deviceCatalog === 6) {
          params.probe = 'magnetism'
          params.devCatalog = 6
        }
        params.scopeName = row.sceneName
        params.carrierName = row.carrierName
        params.carrierId = row.carrierId
        params.carrierTypeId = row.carrierType
        sensorHistory(params)
      } else {
        if (row.deviceCatalog === 1) {
          bus.$emit('gatewayParam', row.deviceId, row.deviceCode)
        } else if (row.deviceCatalog === 2) {
          bus.$emit('displayParam', row.deviceId, row.deviceCode)
        } else if (row.deviceCatalog === 3) {
          bus.$emit('relayParam', row.deviceId, row.deviceCode)
        } else if (row.deviceCatalog === 4) {
          bus.$emit('baseParam', row.deviceId, row.deviceCode)
        }
      }
    },
    close_detail () {
      this.point = null
      this.selectedItem = null
    }
  }
}
</script>

<style scoped lang="scss">
$bg-white: #ffffff;
$bg-gray-50: #f9fafb;
$bg-gray-100: #f3f4f6;
$border-color: #e5e7eb;
$text-900: #111827;
$text-700: #374151;
$text-500: #6b7280;
$text-400: #9ca3af;
$accent: #3b82f6;
$success: #10b981;
$warning: #f59e0b;
$danger: #ef4444;

.plan-overview {
  background: $bg-white;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.plan-header {
  padding: 16px;
  border-bottom: 1px solid $border-color;
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.plan-title {
  font-size: 14px;
  font-weight: 600;
  color: $text-900;
}

.plan-sub {
  font-size: 12px;
  color: $text-400;
}

.view-tabs {
  display: flex;
  background: $bg-gray-50;
  border-radius: 20px;
  padding: 3px;
  gap: 2px;
  margin: 16px;
  border: none;

  ::v-deep .el-radio-button {
    flex: 1;

    .el-radio-button__inner {
      width: 100%;
      padding: 6px 14px;
      border-radius: 18px;
      border: none;
      background: transparent;
      color: $text-500;
      font-size: 12px;
      font-weight: 500;
      transition: all 0.2s;
      box-shadow: none;
    }

    &.is-active .el-radio-button__inner {
      background: $bg-white;
      color: $text-900;
      box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    }
  }
}

.floor-plan-container {
  margin: 0 16px 12px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid $border-color;
  background: $bg-white;
  flex: 1;
  min-height: 600px;
  position: relative;
}

.floor-plan-canvas {
  width: 100%;
  height: 100%;
  display: block;
  cursor: default;
}

.floor-plan-legend {
  display: flex;
  gap: 16px;
  padding: 0 16px 8px;
  font-size: 11px;
  color: $text-400;
  font-weight: 500;
}

.floor-plan-legend-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

.floor-plan-legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;

  &.dot-normal { background: $success; }
  &.dot-warning { background: $warning; }
  &.dot-danger { background: $danger; }
}

.floor-plan-hint {
  margin: 8px 16px 16px;
  padding: 8px 12px;
  background: rgba(59,130,246,0.06);
  border: 1px solid rgba(59,130,246,0.15);
  border-radius: 6px;
  font-size: 12px;
  color: $text-500;
  display: flex;
  align-items: center;
  gap: 6px;

  i { color: $accent; }
}

.device-detail-panel {
  position: fixed;
  background: $bg-white;
  border: 1px solid $border-color;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  z-index: 9999;
  min-width: 200px;
  max-width: 260px;
  pointer-events: auto;
  padding: 10px;
}

.device-detail-header {
  padding: 8px 10px;
  border-bottom: 1px solid $border-color;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.device-detail-title {
  font-size: 12px;
  font-weight: 600;
  color: $text-900;
}

.device-detail-header i {
  color: $text-400;
  cursor: pointer;
  font-size: 14px;
  transition: color 0.2s;

  &:hover { color: $text-700; }
}

.device-detail-content {
  padding: 0;
  font-size: 11px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0,0,0,0.04);

  &:last-child { border-bottom: none; }
}

.detail-label {
  font-size: 12px;
  color: $text-400;
}

.detail-value {
  font-size: 12px;
  color: $text-900;
  font-weight: 500;

  &.status-normal { color: $success; }
  &.status-warning { color: $warning; }
  &.status-danger { color: $danger; }
  &.status-offline { color: $text-400; }
}

.fullscreen-dialog {
  ::v-deep .el-dialog__header {
    display: none;
  }
  ::v-deep .el-dialog__body {
    padding: 0;
    margin: 0;
    height: 100vh;
    background: rgba(0, 0, 0, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.fullscreen-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: zoom-out;
}

.fullscreen-canvas {
  width: 100%;
  height: 100%;
  display: block;
}

.mb-10 {
  margin-bottom: 6px;
}

.color-green {
  color: $success;
}

.color-red {
  color: $danger;
}

.font-14 {
  font-size: 12px;
}

.under-line {
  text-decoration: underline;
  cursor: pointer;
  color: $accent;
  font-size: 11px;
}
</style>
